var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23 23"}},_vm.$listeners),[_c('path',{attrs:{"d":"M16.825 20.461 7.863 11.5l8.962-8.961L14.862.576 3.937 11.5l10.925 10.924 1.963-1.963z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }